import { useSelector } from 'react-redux';

export const useAuthInfo = () => {
  const { isLoggedIn, user: userLogged } = useSelector(state => state.auth);
  const noCustomer = isLoggedIn ? userLogged.noCustomer : '';
  const operationRol = isLoggedIn ? userLogged.operationRol : '---';
  const idCustomer = isLoggedIn ? userLogged.id : "";
  const bajioStatus = isLoggedIn ? userLogged.bajio : false;
  return { noCustomer, operationRol,idCustomer, userLogged, isLoggedIn, bajioStatus };
};